import { jsPDF } from "jspdf";
import autoTable from "jspdf-autotable";
import Intestazione from "../../assets/intestazione-Giuvi-3.png";
import format from "date-fns/format";
import { it } from "date-fns/locale";

async function loadImageAsDataUrl(src) {
  try {
    const res = await fetch(src);
    const blob = await res.blob();
    return new Promise((resolve) => {
      const reader = new FileReader();
      reader.onload = () => resolve(reader.result);
      reader.readAsDataURL(blob);
    });
  } catch (e) {
    return null;
  }
}

export async function downloadNotaSpesePdf({
  autore,
  spese,
  competenza,
  fileName,
}) {
  const doc = new jsPDF({ unit: "mm", format: "a4" });
  const pageWidth = doc.internal.pageSize.getWidth();
  const pageHeight = doc.internal.pageSize.getHeight();
  const marginLeft = 15;
  const marginRight = 15;
  const marginTop = 20;

  const headerImgData = await loadImageAsDataUrl(Intestazione);
  const addHeader = () => {
    const logoX = marginLeft;
    const logoY = 10;
    const logoW = 50;
    const textX = headerImgData ? logoX + logoW + 8 : marginLeft;
    const line1Y = 16;
    const line2Y = 22;
    if (headerImgData) {
      try {
        doc.addImage(headerImgData, "PNG", logoX, logoY, logoW, 0);
      } catch (_) {}
    }
    doc.setFont("helvetica", "normal");
    doc.setFontSize(12);
    doc.text(`Mese: ${competenza} / Nome: ${autore}`, textX, line1Y);
    doc.text(`Nota Spese`, textX, line2Y);
  };
  const addFooter = (pageNumber) => {
    const total = doc.getNumberOfPages();
    doc.setFontSize(10);
    doc.text(
      `Pagina ${pageNumber} di ${total}`,
      pageWidth / 2,
      pageHeight - 10,
      { align: "center" }
    );
  };

  // Prima pagina: tabella riassuntiva
  addHeader();
  const rows = (spese || []).map((s) => [
    s.data
      ? format(s.data.toDate ? s.data.toDate() : s.data, "dd/MM/yyyy", {
          locale: it,
        })
      : "-",
    s.nome || s.descrizioneModificata || "-",
    s.protocollo || "N/A",
    s.importo != null ? `€${s.importo}` : "-",
    s.pagamento || "-",
  ]);

  autoTable(doc, {
    startY: marginTop + 18,
    head: [["Data", "Descrizione", "Protocollo", "Importo", "Pagamento"]],
    body: rows,
    theme: "grid",
    styles: { fontSize: 10, cellPadding: 2, halign: "left" },
    headStyles: { fillColor: [161, 16, 0], textColor: 255, halign: "center" },
    alternateRowStyles: { fillColor: [245, 245, 245] },
    margin: { top: marginTop + 18, left: marginLeft, right: marginRight },
    didDrawPage: () => {
      addHeader();
      addFooter(doc.internal.getCurrentPageInfo().pageNumber);
    },
  });

  // Pagine successive con immagini
  for (const s of spese || []) {
    if (!s.fotoUrl) continue;
    doc.addPage();
    addHeader();
    doc.setFontSize(12);
    doc.text(
      `${s.nome || "Spesa"} - ${s.dettagli || ""}`.trim(),
      marginLeft,
      marginTop + 25
    );
    try {
      const imgData = await loadImageAsDataUrl(s.fotoUrl);
      if (imgData) {
        const imgX = marginLeft;
        const imgY = marginTop + 30;
        const imgW = pageWidth - marginLeft - marginRight;
        doc.addImage(imgData, "JPEG", imgX, imgY, imgW, 0);
      }
    } catch (_) {}
    addFooter(doc.internal.getCurrentPageInfo().pageNumber);
  }

  const finalName = fileName || `NotaSpese_${autore}_${competenza}.pdf`;
  doc.save(finalName);
}
